/* GENERATED by scripts/gen-data.mjs — chapter "evaluate" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_EVALUATE: NodeDef = {
  "id": "evaluate",
  "tagKey": "path:evaluate.tag",
  "x": 40,
  "y": 560,
  "w": 220,
  "h": 116,
  "titleKey": "path:evaluate.title",
  "subKey": "path:evaluate.sub",
  "blocks": [
    {
      "id": "evaluate.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:evaluate.b1.title",
      "bodyKey": "path:evaluate.b1.body",
      "flowKey": "path:evaluate.b1.flow"
    },
    {
      "id": "evaluate.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:evaluate.b2.title",
      "film": "f-evaluate"
    },
    {
      "id": "evaluate.b3o",
      "kind": "options",
      "xp": 20,
      "titleKey": "path:evaluate.b3o.title",
      "opts": {
        "list": [
          {
            "nKey": "path:evaluate.b3o.opts.0.n",
            "wKey": "path:evaluate.b3o.opts.0.w",
            "uKey": "path:evaluate.b3o.opts.0.u",
            "cKey": "path:evaluate.b3o.opts.0.c",
            "slug": "labelled-holdout"
          },
          {
            "nKey": "path:evaluate.b3o.opts.1.n",
            "wKey": "path:evaluate.b3o.opts.1.w",
            "uKey": "path:evaluate.b3o.opts.1.u",
            "cKey": "path:evaluate.b3o.opts.1.c",
            "slug": "judge-model"
          },
          {
            "nKey": "path:evaluate.b3o.opts.2.n",
            "wKey": "path:evaluate.b3o.opts.2.w",
            "uKey": "path:evaluate.b3o.opts.2.u",
            "cKey": "path:evaluate.b3o.opts.2.c",
            "slug": "online-metrics"
          },
          {
            "nKey": "path:evaluate.b3o.opts.3.n",
            "wKey": "path:evaluate.b3o.opts.3.w",
            "uKey": "path:evaluate.b3o.opts.3.u",
            "cKey": "path:evaluate.b3o.opts.3.c",
            "slug": "adversarial-set"
          },
          {
            "nKey": "path:evaluate.b3o.opts.4.n",
            "wKey": "path:evaluate.b3o.opts.4.w",
            "uKey": "path:evaluate.b3o.opts.4.u",
            "cKey": "path:evaluate.b3o.opts.4.c",
            "slug": "monitoring-for-drift"
          }
        ],
        "ref": "checklist"
      }
    },
    {
      "id": "evaluate.b3",
      "kind": "math",
      "xp": 15,
      "titleKey": "path:evaluate.b3.title",
      "math": {
        "exprKey": "path:evaluate.b3.math.expr",
        "readKey": "path:evaluate.b3.math.read",
        "useKey": "path:evaluate.b3.math.use"
      }
    },
    {
      "id": "evaluate.b4",
      "kind": "check",
      "xp": 45,
      "titleKey": "path:evaluate.b4.title",
      "ex": {
        "type": "classify",
        "binsKey": "path:evaluate.b4.ex.bins",
        "binCount": 2,
        "items": [
          {
            "tKey": "path:evaluate.b4.ex.items.0.t",
            "bin": 0,
            "whyKey": "path:evaluate.b4.ex.items.0.why"
          },
          {
            "tKey": "path:evaluate.b4.ex.items.1.t",
            "bin": 1,
            "whyKey": "path:evaluate.b4.ex.items.1.why"
          },
          {
            "tKey": "path:evaluate.b4.ex.items.2.t",
            "bin": 0,
            "whyKey": "path:evaluate.b4.ex.items.2.why"
          },
          {
            "tKey": "path:evaluate.b4.ex.items.3.t",
            "bin": 1,
            "whyKey": "path:evaluate.b4.ex.items.3.why"
          }
        ]
      }
    }
  ]
};
